import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { HelmetProvider } from "react-helmet-async";
import "./index.css";
import App from "./App";
import Store from "./redux/store";
import { initGA } from "./analytics/analytics";
import { CookieConsentProvider } from "./context/CookieConsentContext";
import { fetchCollections } from "./redux/reducers/collection";
initGA();
const homeCollectionParams = {
  limit: 100,
  status: "active",
  division: "Women",
};

if (window.location.pathname === "/") {
  window.__prefetchedCollections = JSON.stringify(homeCollectionParams);
  Store.dispatch(fetchCollections(homeCollectionParams));
}

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <Provider store={Store}>
      <HelmetProvider>
        <CookieConsentProvider>
          <App />
        </CookieConsentProvider>
      </HelmetProvider>
    </Provider>
  </React.StrictMode>,
);
